'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-autowhatever/dist/index.js
// module id = 1157
// module chunks = 0